import React from 'react';
import { Flex, Heading, Text } from 'rebass';
import styled from 'styled-components';
import { signUpComleteContent } from '../content';

const InfoWrapper = styled(Flex)`
  max-width: 860px;
  text-align: center;
  line-height: 1.5;
`;

const RecruiterCompleteStep: React.FC = (): JSX.Element => {
  return (
    <Flex justifyContent="center" pt={20} pb={10}>
      <InfoWrapper flexDirection="column" alignItems="center">
        <Heading fontSize={['42px']} fontWeight={6} mb={10}>
          {signUpComleteContent.recruiter.title}
        </Heading>
        <Text fontSize={['36px']} fontWeight={6}>
          {signUpComleteContent.recruiter.text}
        </Text>
      </InfoWrapper>
    </Flex>
  );
};

export default RecruiterCompleteStep;
